<template>
  <!-- 门户整体布局：顶部导航 + 内容区(路由出口) + 页脚 -->
  <div class="portal">
    <app-header />
    <main class="portal__main">
      <router-view />
    </main>
    <app-footer />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: 'Portal',
  components: { AppHeader, AppFooter }
}
</script>

<style lang="less" scoped>
/* 门户主题变量：定义在根节点，依靠 CSS 变量继承向所有子组件生效 */
.portal {
  --pt-brand: #1e63b0;
  --pt-brand-dark: #15497f;
  --pt-brand-nav: #2266ab;
  --pt-gold: #f6c343;
  --pt-ink: #1f2937;
  --pt-ink-soft: #374151;
  --pt-muted: #9ca3af;
  --pt-line: #eef0f2;
  --pt-line-2: #e5e7eb;
  --pt-bg: #f4f6f9;

  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--pt-bg);
  color: var(--pt-ink);
  /* 使用固定 px 字号，避免受全局 html{font-size:calc(100vw/96)} 缩放影响 */
  font-size: 14px;
  line-height: 1.5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
}

.portal__main {
  flex: 1 1 auto;
  /* header 固定高度补偿：欢迎条 36 + logo 区 56 + nav 0 */
  padding-top: 92px;
}

@media (min-width: 640px) {
  .portal__main {
    /* logo 增高 → 36 + 76 = 112 */
    padding-top: 112px;
  }
}

@media (min-width: 1024px) {
  .portal__main {
    /* nav 显示 → 36 + 76 + 45 = 157 */
    padding-top: 157px;
  }
}
</style>
